const fontWeights = {
  bold: '700',
  extrabold: '800',
  regular: '400',
  semibold: '600',
}

export { fontWeights }
